var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === _vm.names.SURVEYS.STAGE.LIST)?_c('v-container',{staticClass:"page-content px-sm-5",staticStyle:{"margin":"0px","width":"100%"}},[void 0],2):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }